import styled from 'styled-components';

export const FAQContainer = styled.section`
  background: linear-gradient(135deg, #001233 0%, #002855 100%);
  color: #FFFFFF;
  padding: 60px 20px 60px 20px;
  margin: 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 18, 51, 0.1);
    pointer-events: none;
  }
  
  @media (max-width: 768px) {
    padding: 40px 15px 40px 15px;
  }
  
  @media (max-width: 480px) {
    padding: 30px 10px 30px 10px;
  }
`;

export const FAQTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 60px;
  color: #FFFFFF;
  position: relative;
  z-index: 1;
  white-space: normal;
  word-break: keep-all;
  
  background: linear-gradient(135deg, #FFFFFF 0%, #E0E7FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: 1024px) {
    font-size: 2.2rem;
    margin-bottom: 50px;
  }
  
  @media (max-width: 768px) {
    font-size: 1.7rem;
    margin-bottom: 30px;
    line-height: 1.2;
  }
  
  @media (max-width: 480px) {
    font-size: 1.4rem;
    margin-bottom: 25px;
    padding: 0 10px;
  }
`;

export const FAQAccordion = styled.div`
  max-width: 900px;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    max-width: 100%;
    margin: 0 5px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    margin: 0;
    border-radius: 8px;
  }
`;

export const FAQItem = styled.div`
  text-align: start;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.02);
  }
`;

export const FAQQuestionContainer = styled.div`
  padding: 25px 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.isOpen ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.02)'};
  transition: all 0.3s ease;
  position: relative;
  
  /* Adiciona uma linha de destaque quando aberto */
  ${props => props.isOpen && `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(135deg, #FF6600 0%, #FF8533 100%);
    }
  `}
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    transform: translateX(2px);
  }
  
  @media (max-width: 768px) {
    padding: 20px 25px;
    flex-direction: row;
    align-items: flex-start;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    padding: 18px 20px;
    gap: 12px;
  }
`;

export const FAQQuestionText = styled.h4`
  font-size: 1.15rem;
  font-weight: 600;
  margin: 0;
  flex-grow: 1;
  line-height: 1.4;
  color: #FFFFFF;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.05rem;
    line-height: 1.3;
  }
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
    line-height: 1.25;
  }
`;

export const FAQToggleIcon = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
  color: #FF6600;
  margin-left: 20px;
  transition: all 0.3s ease;
  transform: ${props => props.isOpen ? 'rotate(-45deg)' : 'rotate(0deg)'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 102, 0, 0.1);
  flex-shrink: 0;
  
  &:hover {
    background: rgba(255, 102, 0, 0.2);
    transform: ${props => props.isOpen ? 'rotate(0deg) scale(1.1)' : 'rotate(45deg) scale(1.1)'};
  }
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    width: 28px;
    height: 28px;
    margin-left: 15px;
  }
  
  @media (max-width: 480px) {
    font-size: 1.3rem;
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }
`;

export const FAQAnswer = styled.div`
  max-height: ${props => props.isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: ${props => props.isOpen ? '30px' : '0 30px'};
  font-size: 1.05rem;
  line-height: 1.7;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%);
  border-top: ${props => props.isOpen ? '1px solid rgba(255, 255, 255, 0.08)' : 'none'};
  color: rgba(255, 255, 255, 0.9);
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: ${props => props.isOpen ? '25px' : '0 25px'};
    line-height: 1.6;
    max-height: ${props => props.isOpen ? '400px' : '0'};
  }
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
    padding: ${props => props.isOpen ? '20px' : '0 20px'};
    line-height: 1.5;
    max-height: ${props => props.isOpen ? '350px' : '0'};
  }
`;